import { computed, ref, type Ref } from 'vue';
import { useUtilities } from './useUtilities';
import type { AssociationAccount, AssociationContact, ContactLabel } from '@apparatix/types/Leads';
import { AccountAssociated } from '@apparatix/types/Account';

export const useAssociationMiniCards = (accounts: Ref<AssociationAccount[]> | Ref<AccountAssociated[]>, contacts: Ref<AssociationContact[]>) => {
  const accountsLoading = ref(true);
  const contactsLoading = ref(true);

  const { arrayHasValues } = useUtilities();

  const findPrimaryContact = <T extends { contactLabels?: ContactLabel[] }>(_contacts: T[]) => _contacts?.find(
    contact => contact.contactLabels?.some(label => label.contactLabelId === 1),
  );

  const findAccount = () => accounts.value.find(a => a.c2RawType === 'Agency') ?? accounts.value.find(a => a.c2Type?.includes('Advertiser'));

  const shouldShowAccount = computed(() => accountsLoading.value === true ? true : arrayHasValues(accounts.value));

  const shouldShowContact = computed(() => contactsLoading.value === true ? true : arrayHasValues(contacts.value));

  const account = computed(() => arrayHasValues(accounts.value) ? findAccount() : undefined);

  const contact = computed(() => arrayHasValues(contacts.value) ? findPrimaryContact(contacts.value) ?? contacts.value[0] : undefined);

  return {
    account,
    accountsLoading,
    contact,
    contactsLoading,
    shouldShowAccount,
    shouldShowContact,
  };
};
